module.exports = __webpack_public_path__ + "img/amx-16.ec5ce49f.webp";